/* global URLSearchParams, URL */
(function () {
    'use strict';

    // Session filter manager for handling filter persistence
    window.QueryPreserver = {
        // Get current URL query parameters
        getCurrentQueryParams() {
            const urlParams = new URLSearchParams(window.location.search);
            const keys = [...urlParams.keys().map(x => x)]

            // Remove default pagination-only queries
            const isOnlyPage = keys.length === 1 && keys[0] === 'page';
            const isOnlySizeBy = keys.length === 1 && keys[0] === 'size_by';
            // display_as_card
            const isOnlyDisplayAsCard = keys.length === 1 && keys[0] === 'display_as_card';
            const isPageAndSizeBy = keys.length === 2 && keys.includes('page') && keys.includes('size_by');
            if (isOnlyPage || isOnlySizeBy || isOnlyDisplayAsCard || isPageAndSizeBy) {
                return new URLSearchParams('');
            }
            return urlParams;
        },
        // Clear filters by redirecting to clear_filters=1
        clearPageQuery() {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('clear_filters', '1');
            window.location.href = currentUrl.toString();
        },
        get hasQueryParams() {
            return this.getCurrentQueryParams().toString() !== '';
        }
    };

})();
